import { replaceTokens } from '@/utils';
import ApiClient from '../../client';
import { createNamespacedDataProviderStore, extendStore } from './dataprovider';

// The store keeps the pages exactly as the API returned them, merge tags still in place.
// Tags used to be resolved once, at fetch time, and the resolved text cached: a fetch that ran
// before the profile had loaded (reload, reconnect) or with an older profile baked blank or stale
// values into the cache, and `fetchItems` never refetches while items exist - only a re-login
// reset it. Resolving in the getter instead re-runs whenever the profile changes.
const store = createNamespacedDataProviderStore((setItems) =>
  ApiClient.getLivePages().then((response) => setItems(response.data))
);

export default extendStore(store, {
  getters: {
    getItems: (state, _getters, _rootState, rootGetters) => {
      const user = rootGetters['Authentication/getUser'];

      return state.items.map((page) => ({
        ...page,
        Tekst: replaceTokens(page.Tekst, user)
      }));
    }
  }
});
